import { back } from '@/utils/back'

export const backPlugin = {
  install(Vue) {
    window.backPressed = () => {
      back()
    }
    Vue.mixin({
      methods: {
        $back() {
          back(...arguments)
        }
      }
    })
  }
}
